export default __webpack_public_path__ + "static/media/internalServerError.ac2b18d6.svg";